import { render } from "./SelectNew.vue?vue&type=template&id=577ec789&ts=true"
import script from "./SelectNew.vue?vue&type=script&lang=ts"
export * from "./SelectNew.vue?vue&type=script&lang=ts"

import "./SelectNew.vue?vue&type=style&index=0&id=577ec789&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__